import React, { lazy, Suspense, useEffect } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';
import { initMetaPixel } from './utils/metaPixel';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const SocialProof = lazy(() => import('./components/sections/SocialProof').then(mod => ({
  default: mod.SocialProof
})));
const Differentiators = lazy(() => import('./components/sections/Differentiators').then(mod => ({
  default: mod.Differentiators
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const AboutAuthor = lazy(() => import('./components/sections/AboutAuthor').then(mod => ({
  default: mod.AboutAuthor
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="d3cuxpqygsfi">
      <div className="w-full min-h-full bg-white font-body text-gris-texto" data-id="element-1" data-mp="d2bh5dik1ru3">
        <main data-id="element-2" data-mp="86cm572q1bkp">
          <Hero data-id="element-3" data-mp="83qgjcze5654" />
          <Suspense fallback={null} data-id="element-4" data-mp="3gl4srkrrw6lm">
            <SocialProof data-id="element-5" data-mp="3gmfsn9i3ku7g" />
            <Differentiators data-id="element-6" data-mp="3glnz048296jt" />
            <Transformation data-id="element-7" data-mp="3bmbazg5gdtfn" />
            <Method data-id="element-8" data-mp="3bncpjulogy24" />
            <ForYou data-id="element-9" data-mp="3bnuudfmeokln" />
            <WhatYouGet data-id="element-10" data-mp="3bk720jsp648i" />
            <InstantAccess data-id="element-11" data-mp="3qaxsnoijyxa1" />
            <Testimonials data-id="element-12" data-mp="3qc966g1svjec" />
            <AboutAuthor data-id="element-13" data-mp="3qciln9p7y85s" />
            <Pricing data-id="element-14" data-mp="3lkheg26wr7mm" />
            <Guarantee data-id="element-15" data-mp="3ljxtsdpvi54w" />
            <FAQ data-id="element-16" data-mp="3ljphoo1kr3ur" />
            <FinalCTA data-id="element-17" data-mp="3lj6b23hdk1w1" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-18" data-mp="2xuddy3p0nnzu">
          <Footer data-id="element-19" data-mp="2xtc05rgm8nef" />
        </Suspense>
        <StickyCTA data-id="element-20" data-mp="2svtmjnrnlk03" />
      </div>
    </LazyMotion>;
}